module.exports = __webpack_public_path__ + "static/media/proudly.4c657d7f.png";